import React from 'react';
import {
  Box,
  VStack,
  HStack,
  Pressable,
  Icon,
} from '@gluestack-ui/themed';
import { Trash2 } from 'lucide-react-native';
import FormField from '../../../../common/components/forms/FormField';

interface CriterionItemProps {
  dimensionIndex: number;
  criterionIndex: number;
  dimensionColor: string;
  isReadOnly: boolean;
  onRemove: (index: number) => void;
}

/**
 * CriterionItem component handles a single criterion within a dimension
 */
const CriterionItem: React.FC<CriterionItemProps> = ({
  dimensionIndex,
  criterionIndex,
  dimensionColor,
  isReadOnly,
  onRemove,
}) => (
  <Box
    borderWidth={1}
    borderColor="$borderLight"
    borderLeftWidth={3}
    borderLeftColor={dimensionColor}
    borderRadius="$md"
    p="$3"
    $base-w="100%"
    $md-w="32%"
    $lg-w="32%"
    bg="$bgCard"
    sx={{
      _web: {
        transition: 'all 0.2s ease-in-out',
        ':hover': { borderColor: dimensionColor },
      },
    }}
  >
    <VStack flex={1}>
      {!isReadOnly && (
        <HStack justifyContent="flex-end">
          <Pressable onPress={() => onRemove(criterionIndex)}>
            <Icon as={Trash2} size="xs" color="$textSubtle" />
          </Pressable>
        </HStack>
      )}

      <HStack space="xs" alignItems="flex-start">
        <Box flex={1}>
          <FormField
            type="text"
            name={`rubric.dimensions.${dimensionIndex}.criteria.${criterionIndex}.name`}
            placeholder="Criterion name"
            readonly={isReadOnly}
            fieldSize="sm"
          />
        </Box>
        <Box width={52}>
          <FormField
            type="number"
            name={`rubric.dimensions.${dimensionIndex}.criteria.${criterionIndex}.pts`}
            placeholder="Pts"
            readonly={isReadOnly}
            fieldSize="sm"
          />
        </Box>
      </HStack>

      <FormField
        type="textarea"
        name={`rubric.dimensions.${dimensionIndex}.criteria.${criterionIndex}.descriptor`}
        placeholder="Description of what is expected"
        readonly={isReadOnly}
        fieldSize="xs"
        fieldHeight={100}
      />
    </VStack>
  </Box>
);

export default CriterionItem;
